export const DANGER = '#ef4444';
